import { useTranslation } from 'react-i18next';
import { pillarArticles } from '@/mocks/articles';

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800 mb-3">
            {t('pillar_h2')}
          </h2>
          <p className="text-sm md:text-base text-stone-500 max-w-2xl mx-auto">
            {t('pillar_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {pillarArticles.map((article) => (
            <a
              key={article.slug}
              href={`/${article.slug}/`}
              className="group flex flex-col p-5 md:p-6 rounded-xl bg-stone-50 border border-stone-200 hover:border-emerald-300 hover:bg-white transition-all"
            >
              <span className="inline-flex items-center gap-1.5 self-start px-2.5 py-1 text-xs font-semibold text-emerald-700 bg-emerald-50 rounded-full mb-3">
                <i className="ri-bookmark-line" />
                {article.category}
              </span>
              <h3 className="text-base md:text-lg font-semibold text-stone-800 leading-snug mb-2 group-hover:text-emerald-700 transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-stone-500 leading-relaxed mb-4 flex-1">
                {article.excerpt}
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-emerald-700 group-hover:text-emerald-800 transition-colors">
                {t('pillar_read')}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}